import { call, put, select } from 'redux-saga/effects';
import { Action } from '@reduxjs/toolkit';
import { hasPermissionsSaga } from 'features/permissions/sagas/hasPermissionsSaga';
import { PermissionTypes } from 'features/permissions/types';
import { selectNotificationsByScope } from 'features/notifications/notificationsSlice';
import { NotificationId } from 'features/notifications/types';
import { closeActionNotification } from 'features/notifications/thunks/closeActionNotification';

interface PermissionChecks {
  canManage: boolean;
  canTakePolls: boolean;
}

export function* checkPermissionsSaga() {
  const canManage: boolean = yield call(hasPermissionsSaga, PermissionTypes.managePolls);
  const canTakePolls: boolean = yield call(hasPermissionsSaga, PermissionTypes.takePolls);

  return {
    canManage,
    canTakePolls,
  };
}

export function* handleRoleChangePollsPermissionsSaga() {
  const permissionChecks: PermissionChecks = yield call(checkPermissionsSaga);

  if (!permissionChecks.canTakePolls) {
    const notifications: NotificationId[] = yield select(
      selectNotificationsByScope,
      'poll_request_vote'
    );

    if (notifications.length) {
      const cleanupNotificationThunk: Action = yield call(
        closeActionNotification,
        notifications[0]
      );
      yield put(cleanupNotificationThunk);
    }
  }
}
